var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9335 4.89336L11.1069 3.06669C10.8685 2.84276 10.5561 2.71427 10.2291 2.70566C9.90211 2.69706 9.58338 2.80894 9.33353 3.02003L3.33353 9.02003C3.11804 9.23734 2.98387 9.52216 2.95353 9.82669L2.66686 12.6067C2.65788 12.7043 2.67055 12.8028 2.70397 12.895C2.73739 12.9871 2.79073 13.0708 2.8602 13.14C2.92249 13.2018 2.99637 13.2507 3.07759 13.2839C3.15882 13.3171 3.24579 13.3339 3.33353 13.3334H3.39353L6.17353 13.08C6.47806 13.0497 6.76289 12.9155 6.9802 12.7L12.9802 6.70003C13.2131 6.45401 13.3389 6.1257 13.3302 5.78705C13.3214 5.4484 13.1788 5.12703 12.9335 4.89336ZM6.05353 11.7467L4.05353 11.9334L4.23353 9.93336L8.0002 6.21336L9.8002 8.01336L6.05353 11.7467ZM10.6669 7.12003L8.8802 5.33336L10.1802 4.00003L12.0002 5.82003L10.6669 7.12003Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit_pen.dc6c87010c3da0b1d0edce2e91378849.svg";
export { ForwardRef as ReactComponent };